module.exports = function (app) {
    'use strict';
    app.controller('pages.cancelledConditions', ['$scope', '$state', 'sessionData', 'navigation', 'modal', 'services',
        function ($scope, $state, sessionData, navigation, modal, services) {

            if (!(sessionData && sessionData.employerInfo && sessionData.employerInfo.planAdministrator)) {
                return;
            }

            // Add a temporary filter to navigation that will reject all items.
            navigation.setFilter("cancelledClient", function(item) {
                return false;
            }, {
                temp: true
            });
            navigation.setFilter("cancelledClientLogos", function(item) {
                item.state = '.';
                return item;
            }, {
                temp: true
            });
            // Update all navigation modules, to apply the temporary filter to remove all links.
            navigation.addTempFilterToModules(["socialLinksHMHS", "footerLinks", "footerTabsThree", "userTabs", "headerTabs"], "cancelledClient");
            navigation.addTempFilterToModules(["logo", "footerLogo"], "cancelledClientLogos");
            navigation.update();

            $scope.isIbc = ((sessionData.employerInfo.brandName == '6008')
                            || (sessionData.employerInfo.brandName == '6008')) ? true : false;
            var planAdmin = sessionData.employerInfo.planAdministrator;
            $scope.username = planAdmin.firstName + ' ' + planAdmin.lastName;
            $scope.company = planAdmin.company;

            $scope.entitlements = sessionData.entitlements;

            $scope.showContinueModal = function() {
                modal.open({
                    heading: 'Acknowledgement',
                    template: require('pages/home/modals/they-agreed.html')
                });
                services.eprsvc.cancelledClientEmail().post();
                sessionData.cancelledClientHasAgreed = true;
                $state.go('home');
            };
            $scope.goToMemberLanding = function () {
                // window.location.origin  // that yeilds http ... .com
                //         https://tenv3.highmarkbcbs.com/home/
                window.location.href = window.location.origin + '/home'
            }
            $scope.displayPrinterFriendly = function() {
                window.print();
            }
        }
    ]);
    return [
        {
            state: 'cancelledConditions',
            url: '/cancelled-conditions',
            views: {
                'body@': {
                    template: bootstrap.templates['page-templates/hmhs/landing-page.html'],
                    controller: 'pages.cancelledConditions'
                },
                'dashboard@cancelledConditions': {
                    templateUrl: 'cancelled-conditions.employerTemplate.html/pages/home/cancelledConditions'
                }
            }
        }
    ];
};
